import tableOperation from '../common/table-operation'

const fetchLocalPhoneNumbers = async function (
  { commit, state, getters },
  config
) {
  const { paginationConfig } = config
  commit('setTable', paginationConfig)

  const filteredCollection = getters.getSearchedPhoneNumbers
  commit('setTableRecordsCount', filteredCollection?.length)

  const result = {
    incoming_phone_numbers: tableOperation.getPaginatedCollection({
      collection: [...filteredCollection],
      paginationConfig: paginationConfig,
    }),
  }

  return Promise.resolve(result)
}

export default fetchLocalPhoneNumbers
